// Keep in sync with utils/address.js.
// Create React App cannot import files outside client/src.

const text = (value) => String(value || "").trim();

function formatUnit(unit) {
  const value = text(unit);
  if (!value) return "";
  return `Διαμ. ${value}`;
}

function formatAddress(address) {
  if (!address || typeof address !== "object") return "";
  const place = [text(address.city), text(address.zip)].filter(Boolean).join(" ");
  const main = [text(address.street), text(address.district), place].filter(Boolean).join(", ");
  const unit = formatUnit(address.unit);
  if (!unit) return main;
  return main ? `${main} (${unit})` : `(${unit})`;
}

function companyAddressLines(address) {
  const formatted = formatAddress(address);
  const match = formatted.match(/\(([^)]+)\)/);
  if (!match) return formatted ? [formatted] : [];
  const postal = `(${match[1].trim()})`;
  const rest = formatted
    .replace(match[0], " ")
    .replace(/\s+,/g, ",")
    .replace(/,\s*,/g, ",")
    .replace(/^[,\s]+|[,\s]+$/g, "")
    .replace(/\s{2,}/g, " ")
    .trim();
  return [rest, postal].filter(Boolean);
}

function primaryAddress(source) {
  if (!source || typeof source !== "object") return null;
  const addresses = Array.isArray(source.addresses) ? source.addresses.filter(Boolean) : [];
  if (addresses.length) return addresses.find((item) => item.isBilling) || addresses[0];
  if (source.address && typeof source.address === "object") return source.address;
  if (source.street || source.district || source.city || source.zip || source.unit) return source;
  return null;
}

module.exports = { companyAddressLines, formatAddress, primaryAddress };
